var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8135 0.564818C24.5397 -1.16135 27.161 1.46058 25.4354 3.18676L15.6219 13L25.4349 22.8132C27.161 24.5394 24.5391 27.1614 22.813 25.4352L13 15.6219L3.18646 25.4352C1.46033 27.1614 -1.16101 24.5394 0.564585 22.8132L10.3781 13L0.565121 3.18676C-1.16101 1.46058 1.46087 -1.16135 3.18699 0.564818L13 10.3781L22.8135 0.564818Z",
    fill: "#008C99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete (2).23ef0cb01114fa41a9be84e270fd2a13.svg";
export { ForwardRef as ReactComponent };